import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xe4ssf4af: FaireProductEntity = {
  token: "p_6xe4ssf4af",
  type: "product",
  name: "EXCLUSIVE FLORAL PATCHWORK TIE STRAP MIDI DRESS MDR4718",
  brandToken: "b_2orbuphvsb",
  brandName: "&MERCI",
  imageUrl:
    "https://cdn.faire.com/fastly/d33b110f198f91e8611b7f9531c2a8afde4988f5d7e589b0e46fb5ea9eb47ec9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a9c3b67021d8a0e9fd9835fac1eeb3ee0a2d2401c07e6738a8e914555ece9d0.jpeg",
    "https://cdn.faire.com/fastly/f137bdadc4edc63348767c64b81e26d6b8fe4e18468a52214aab2d61189501e9.jpeg",
    "https://cdn.faire.com/fastly/e7801c588deab7124181f129763c094afeebdcef4b1bde7c799bbc491fd0826d.jpeg",
    "https://cdn.faire.com/fastly/6e809d1787f37f2c6ce39907d26bed86e5a0dcc96ab4235265dd3331e729a29c.jpeg",
    "https://cdn.faire.com/fastly/d300fd7ea4f8fef06555abc5f4e2fa88adf85f3975dd0dfd9d85e7acc53313e5.jpeg",
    "https://cdn.faire.com/fastly/d34cb1354c129285e675f87c143aefe2ccea931ddb721b87dc533225d37951d6.jpeg",
    "https://cdn.faire.com/fastly/a181ebc0a57c8d46982140f34572de2ba878d2662d8f0952c2e6382452fbf7bd.jpeg",
    "https://cdn.faire.com/fastly/f3f8f75f6e8681a4d7c1611f1a48d8f94d047fd0aab9d04697b298cc6f19125b.jpeg",
    "https://cdn.faire.com/fastly/3fb2738478e2030972685c7241da86720a1c73981dc3cf29e8deb329b8ad8365.jpeg",
    "https://cdn.faire.com/fastly/5aa4b5e6858d7d4abea409ea346bbb01eb4e87cce32cb9f445912fc2497e6ddb.jpeg",
    "https://cdn.faire.com/fastly/9f19ab0ff7e3c855f95a49553391acd359c08abe6650b5657c1cf3da778a47a3.jpeg",
    "https://cdn.faire.com/fastly/d67c90534cc498849b2dbdac36347bff80c7a3cab9e521a31d2c9db9fb2f60ed.jpeg",
    "https://cdn.faire.com/fastly/2f4e8901e906f03a4db31a13fdae8579d38071b77110e6629ff706763fcb1500.jpeg",
    "https://cdn.faire.com/fastly/0225e2ad0bee6fc117996f7dfcf9e022d3a7c3bcbcf812d1bbd62557af90a1ef.jpeg",
    "https://cdn.faire.com/fastly/a682db0582f6c026970828a672e482325b28a1a8584e60c2736313539891de43.jpeg",
    "https://cdn.faire.com/fastly/c0915dc33956536b8978ee07eed267575d7d4046645c49b6c779aca24be938d6.jpeg",
    "https://cdn.faire.com/fastly/5e317db9d103781870ef3f70a07f4f42934b00121fe7b4152ad965f4e4601739.jpeg",
  ],
  priceDollars: 184.5,
  description:
    "+ Floral patchwork tie strap midi dress\n+ &merci exclusive print\n+ Fitted bodice\n+ Straight neckline\n+ Wide tying straps\n+ Smocked elastic back\n+ Tiered midi\n+ Pockets\n+ Lined\n+ Model is 5' 7\" 30-24-34.5 and wears a S",
  tags: [],
  msrpDollars: 369,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:00.199Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
